import { CancelVoPayInstantRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useCancelVoPayInstant({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function cancelVoPayInstant(params: CancelVoPayInstantRequest) {
    try {
      setFetching(true);
      const res = await api.postCancelVoPayInstant(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, cancelVoPayInstant };
}
